import { render, staticRenderFns } from "./px-notice-bar.vue?vue&type=template&id=1bec9539&scoped=true&"
import script from "./px-notice-bar.vue?vue&type=script&lang=ts&"
export * from "./px-notice-bar.vue?vue&type=script&lang=ts&"
import style0 from "./px-notice-bar.vue?vue&type=style&index=0&id=1bec9539&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bec9539",
  null
  
)

export default component.exports